import { render, staticRenderFns } from "./toolbar-btn.vue?vue&type=template&id=37cacefc&scoped=true&"
import script from "./toolbar-btn.vue?vue&type=script&lang=ts&"
export * from "./toolbar-btn.vue?vue&type=script&lang=ts&"
import style0 from "./toolbar-btn.vue?vue&type=style&index=0&id=37cacefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cacefc",
  null
  
)

export default component.exports